import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';
import { Icon } from '@successmode-ktp/kui';

interface IProps {
  totalPage: number;
  pageNumber?: number;
  setPageNumber: Dispatch<SetStateAction<number>>;
}

interface IPage {
  selected: number;
}

const PagingWithLastPage = ({
  pageNumber,
  setPageNumber,
  totalPage,
}: IProps) => {
  const onChange = ({ selected }: IPage) => {
    setPageNumber(selected);
  };

  const handleFirstPage = () => {
    setPageNumber(0);
  };

  const handleLastPage = () => {
    setPageNumber(totalPage - 1);
  };

  const isFirstPage = pageNumber === 0;
  const isLastPage = pageNumber === totalPage - 1;

  if (totalPage <= 0) {
    return null;
  }

  return (
    <PaginationWrapper>
      <FirstPageButton onClick={handleFirstPage} disabled={isFirstPage}>
        <Icon.ChevronDoubleLeft
          size={18}
          fillColor={isFirstPage ? '#CBCCCE' : '#3A3B3E'}
        />
      </FirstPageButton>
      <StyledPaginate
        pageCount={totalPage}
        marginPagesDisplayed={4}
        pageRangeDisplayed={5}
        previousLabel={
          <Icon.ChevronLeft
            size={18}
            fillColor={isFirstPage ? '#CBCCCE' : '#3A3B3E'}
          />
        }
        nextLabel={
          <Icon.ChevronRight
            size={18}
            fillColor={isLastPage ? '#CBCCCE' : '#3A3B3E'}
          />
        }
        onPageChange={onChange}
        previousClassName={'previous'}
        nextClassName={'next'}
        disabledClassName={'disabled'}
        activeClassName={'active'}
        forcePage={pageNumber}
      />
      <LastPageButton onClick={handleLastPage} disabled={isLastPage}>
        <Icon.ChevronDoubleRight
          size={18}
          fillColor={isLastPage ? '#CBCCCE' : '#3A3B3E'}
        />
      </LastPageButton>
    </PaginationWrapper>
  );
};

const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledPaginate = styled(ReactPaginate)`
  display: flex;
  justify-content: center;
  gap: 6px;
  list-style: none;
  font-size: 15px;
  z-index: 1;

  li a {
    padding: 8px;
    color: #bdbdbd;
    cursor: pointer;
    color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
    text-align: center;

    /* WebBody/14_MD */
    font-family: Pretendard;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */
    letter-spacing: -0.28px;
    &:hover {
      opacity: 0.8;
    }
  }

  li.active a {
    color: var(--KTP-Grayscale-100, var(--KTP-Color-Mono-100, #030303));
  }

  li.disabled a {
    pointer-events: none;
    color: #bdbdbd;
    opacity: 0.8;
  }

  .previous {
    margin-right: 46px;
    a {
      padding: 0;
    }
  }
  .next {
    margin-left: 46px;
    a {
      padding: 0;
    }
  }
`;

const FirstPageButton = styled.button`
  padding: 0;
  cursor: pointer;
  color: ${(props) => (props.disabled ? '#ccc' : '#246CF6')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

const LastPageButton = styled.button`
  padding: 0;
  cursor: pointer;
  color: ${(props) => (props.disabled ? '#ccc' : '#246CF6')};
  pointer-events: ${(props) => (props.disabled ? 'none' : 'auto')};
`;

export default PagingWithLastPage;
